import React from "react"
import Layout from "../../components/layout"
import Hero from "../../components/hero"
import TextWithImage from "../../components/text-with-image"
import ReadNext from "../../components/read-next"

export default function Home() {
  return (
    <Layout>
      <section className="page page--pullBottom page--margin-medium">
        <Hero
          title="What We Do"
          text="The IMF’s three main roles are economic surveillance, lending, and capacity development."
          image="what-we-do/hero.jpg"
        />

        <div className="container md:container--large">
          <TextWithImage
            image="what-we-do/economic-surveillance/economic-surveillance-large-thumbnail.jpg"
            title="Economic Surveillance"
            stat="36 Country Health Checks"
            target="/what-we-do/economic-surveillance"
          >
            <p>
              The IMF monitors the international monetary system as well as the
              economic and financial policies of its 190 member countries. As
              part of this monitoring, known as surveillance, which takes place
              both at the global level and in individual countries, the IMF
              highlights possible risks to stability and advises on policy
              adjustments to address these risks.
            </p>
          </TextWithImage>

          <TextWithImage
            image="what-we-do/lending/lending-large-thumbnail.jpg"
            title="Lending"
            stat="$98 billion to 54 countries"
            caption="including $10 billion to 31 low-income countries, for a total of $110 billion since the start of the pandemic"
            target="/what-we-do/lending"
            classes="text-with-image--reverse"
          >
            <p>
              Of this lending, the IMF channeled $17 billion (equivalent to SDR
              12 billion) in financing to 39 countries through emergency lending
              facilities, of which $6 billion was provided to 26 low-income
              countries.
            </p>
            <p>
              The IMF provides financing to member countries experiencing
              actual, potential, or prospective balance of payments problems to
              help them rebuild their international reserves and restore
              conditions for strong economic growth, while correcting underlying
              problems. The IMF also provides fast-disbursing emergency
              financing with limited conditionality and has greatly expanded
              such financing to help member countries address the immediate
              economic impact of the COVID-19 pandemic.
            </p>
          </TextWithImage>

          <TextWithImage
            image="what-we-do/capacity-development/capacity-development-large-thumbnail.jpg"
            title="Capacity Development"
            stat="$251 million"
            caption="for hands-on technical advice, policy-oriented training, and peer learning"
            target="/what-we-do/capacity-development"
          >
            <p>
              The IMF works with countries to strengthen their economic
              institutions by providing technical assistance and training on
              critical economic issues. This work helps countries strengthen
              their economies and create more jobs. The IMF shares its knowledge
              with government institutions such as finance ministries, central
              banks, statistical agencies, financial supervisory agencies, and
              revenue administrations through hands-on advice, training, and
              peer-to-peer learning. IMF capacity development is delivered in
              person and remotely by long-term resident advisors in country or
              at regional CD centers, during short-term visits by IMF staff and
              experts, and through classroom training and free online courses.
            </p>
          </TextWithImage>
        </div>
      </section>

      <ReadNext sectionID="what-we-do" pageID="economic-surveillance" />
    </Layout>
  )
}
